import React, { useEffect, useState } from 'react';
import { Footer, Header } from '@stitch-fix/knit';
import { Box } from '@stitch-fix/mode-react';
import { recordCustomTiming } from '@stitch-fix/client-analytics-reporter';
import { isIosApp } from '../../utils/helpers';
import { LandingScreenViewTracking, type LandingScreenViewTrackingProps } from '../LandingScreenViewTracking';
import { useIncentiveBanner, type UseIncentiveBannerProps } from '../../hooks/useIncentiveBanner/useIncentiveBanner';
export interface LayoutProps {
  forceHideHeaderFooter?: boolean;
  viewEventContentId?: LandingScreenViewTrackingProps['contentId'];
  viewEventTrackingName?: LandingScreenViewTrackingProps['name'];
  children: React.ReactNode;
  footerRef?: React.RefCallback<HTMLDivElement>;
  customSlimBanner?: UseIncentiveBannerProps['customSlimBanner'];
}
export const Layout = ({
  children,
  viewEventContentId,
  viewEventTrackingName,
  forceHideHeaderFooter = false,
  footerRef,
  customSlimBanner
}: LayoutProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const shouldRenderHeaderFooter = !forceHideHeaderFooter && !isIosApp(isMounted ? window.navigator.userAgent : '');
  const {
    showBannerPlaceholder,
    banner,
    slimBanner,
    modal
  } = useIncentiveBanner({
    customSlimBanner,
    hideHeaderFooter: !shouldRenderHeaderFooter
  });
  useEffect(() => {
    setIsMounted(true);
    recordCustomTiming('landingpages_metric_react_app_boot');
    return () => {
      setIsMounted(false);
    };
  }, []);
  return <LandingScreenViewTracking contentId={viewEventContentId} name={viewEventTrackingName}>
      {shouldRenderHeaderFooter && <Header region="US" banner={banner} slimBanner={slimBanner} />}
      {isMounted && modal}
      {/* Hold open a spot for the banner to prevent shift */}
      {showBannerPlaceholder && <Box height="68px" />}
      {/* setting this id allows the "Skip to page content" link to render from knit  */}
      <main id="knit-main-content">{children}</main>
      {shouldRenderHeaderFooter && <Box ref={footerRef}>
          <Footer region="US" />
        </Box>}
    </LandingScreenViewTracking>;
};